<template>
    <carrier-products admin="true"></carrier-products>
</template>
<script type="text/babel">
    import CarrierProducts from '../carriers/CarrierProducts.vue';

    export default {
        data: function () {
            return {
                carrier_id: '',
                carrierDetails: {},
                carrierProducts:[]
            }
        },
        components: {
            CarrierProducts,
        },
        created(){
            this.carrier_id = this.$route.params.carrier_id || null;
            this.fetchCarrierData();
        },
        methods:{
            fetchCarrierData(){
                this.$send(this, 'carrierDetails', {
                    carrier_id: this.$route.params.carrier_id
                }).then(r => {
                    this.carrierDetails = r.carrierDetails;
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Products.vue?12d75336